import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'',minmax:[],workinghours:[], Costs:'', States:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/minmaxloans.php')
			.then(result => {				
				this.setState({minmax:result.data})													
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/hours.php')			
			.then(result => {	
				this.setState({workinghours:result.data});
			})	
		axios.post(process.env.REACT_APP_API_ENV+'api/findOntario.php')			
			.then(result => {	
				this.setState({Costs:result.data[2]});
				this.setState({States:result.data[1]});
			})	
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Payday Loan Questions"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>Frequently Asked Questions</small></h1>								
				<div id="bottom"><br/>
					<h2>What is a Payday Loan?</h2>
					<label style={{color:"grey"}}>A payday loan is intended to address short-term financial needs. It's also called payday advance, 
						cash advance or payroll loan. Typically, the Loan is repaid on your next scheduled pay date. When a payday loan is obtained 
						through <strong>{this.state.CompName}</strong>, funds will be deposited directly into your bank account.</label>
					<h2 >Why do we choose a Payday Loan?</h2>
					<label style={{color:"grey"}}>Many of Canadians find that payday loans are the perfect solution to their short term financial needs.
						Sometimes they are short on cash and can't wait until their next pay day. 
						A payday loan is a quick access	to the money they want to address their short term financial needs</label>
					<h2>How do I qualify for a Payday loan?</h2>
					<label style={{color:"grey"}}>
						<ul><li> You must be eighteen (18) years of age at least</li>
							<li> You must be employed and have steady income directly deposited into your banking account</li>
							<li> You must have an active chequing account</li>
							<li> You must be a Canadian citizen or Permanent Resident</li>
							<li> You must have a valid email address and active phone number</li>
						</ul>
					
					<p>Regardless of the above requirements, the final decision on all applications is the sole discretion of {this.state.CompName}</p>
					<p>If you meet these requirements, you must follow the application steps</p></label>
					<h2>How much money may I borrow?</h2>
					<label style={{color:"grey"}}>The amount of cash you can borrow depends on your net income. It's between ${this.state.minmax[0]} and ${this.state.minmax[1]} in increments of ${this.state.minmax[0]}. 
						Minimum is ${this.state.minmax[0]}, maximum ${this.state.minmax[1]}, subject to approval, for the first time borrower. You can borrow more when you successfully repay your first loan.</label>
					<h2>How quick can I get approved for a payday loan?</h2>
					<label style={{color:"grey"}}>If all requirements are met and if you select on-line banking method in your application the loan may be deposited into your 
						account as fast as 30 minutes after application receiving and approval. Generally we may finish one case within half day and this will depend on banking processing. 
						Our working hours are weekdays (Monday - Friday, {this.state.workinghours[0]} - {this.state.workinghours[1]}) excluding public holidays.</label>
					<h2>How do I know my application has been approved?</h2>
					<label style={{color:"grey"}}>We will send you the notice via email you provided in the application and we may inform you by phone</label>
					<h2>How about credit checks?</h2>
					<label style={{color:"grey"}}>We are not going to check your credits at all</label>
					<h2>Do you always call my employer?</h2>
					<label style={{color:"grey"}}>We strongly recommend you to provide us your on-line banking information for the loan processing which is
							fast, secure, and accurate that we don't have to contact your employer any more. However, if no such information is 
					provided, we probably need do it to verify your employment. But, your privacy is very important to us and your loan application will not be revealed</label>
					<h2>How do I receive my loan?</h2>
					<label style={{color:"grey"}}>The loan will be directly deposited into your bank account</label>
					<h2>What are fees involved?</h2>
					<label style={{color:"grey"}}>Loan rates vary from province to province. It includes principal, interest, accrued fees and others. For example: 
						if you borrow $100 for one week, the cost is ${this.state.Costs + ' (' + this.state.States+')'}  when you repay it in full on time. No hidden fees at all</label>
					<h2>How do I pay back money?</h2>
					<label style={{color:"grey"}}>The Loan you borrowed from Loan2u plus the cost involved will be debited from your bank account on your next scheduled pay date</label>
					<h2>How long should I pay back money?</h2>
					<label style={{color:"grey"}}>Repayment date is your next payment date and maximum term of the loan is no more than 31 days</label>
				</div>								
			</div>
		)
	}
}

export default HomtContents